import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FirmwareUpdateStore } from '@store';

@Component({
  selector: 'app-firmware-update-up-to-date',
  templateUrl: './firmware-update-up-to-date.component.html',
  styleUrls: ['./firmware-update-up-to-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateUpToDateComponent {
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  constructor(public firmwareUpdateStore: FirmwareUpdateStore) {}

  onClose(): void {
    this.cancel.emit();
  }
}
